import { downloadPhoneDiagnostics } from '../helper/phoneDiagnostics';
import React, { useEffect } from 'react';
import { CallGETAPI } from '../helper/Constants';
import usePhoneConnection from '../helper/usePhoneConnection';

export default function SIPAdminHandler() {
  const { connectPhone, phoneStatus } = usePhoneConnection();
  useEffect(() => {
    let cancelled = false;
    CallGETAPI('api/get-user-extension').then(response => {
      const credentials = response?.data?.data;
      if (!cancelled && credentials?.browser_compatible !== false) {
        connectPhone(credentials || {});
      }
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [connectPhone]);
  return <div role="status" className="fixed bottom-2 right-4 z-50 rounded bg-white px-3 py-1 text-xs text-slate-700 shadow">{phoneStatus} <button type="button" className="ml-2 underline" onClick={downloadPhoneDiagnostics}>Download diagnostics</button></div>;
}
